import api from "../../../api";

export function settings() {
  return api.get("/settings");
}

export function addSetting(payload) {
  return api.put("/settings", payload);
}

export function serviceablePincode() {
  return api.get("serviceable-pincodes");
}
export function blockedCustomers() {
  return api.get("blocked-customers");
}

export function nonserviceableCombination() {
  return api.get("non-servicable-combinations");
}
export function uploadServiceablePincode(payload){
    return api.put(`serviceable-pincodes`, payload)
}
export function uploadBlockedCustomers(payload){
  return api.put(`blocked-customers`, payload)
}

export function uploadNonServiceablecombination(payload){
  return api.put(`non-servicable-combinations`, payload)
}
